import { Lightning } from "@lightningjs/sdk";
import { gridHeight, gridWidth } from "../../services/grid.service";
import LoggerService from "../../services/logger.service";

export default class ConsoleComponent extends Lightning.Component {
  static _template() {
    return {
      color: 0xcc000000,
      w: 24 * gridWidth,
      h: 12 * gridHeight,
      mountY: 1,
      y: 1080,
      rect: true,
      Logs: {
        x: 2 * gridWidth,
        y: 1 * gridHeight,
        h: 10 * gridHeight,
        w: 20 * gridWidth,
        flex: { direction: "column" },
      },
    };
  }

  _init() {
    this.logs = [];

    LoggerService.on("log_data", data => {
      this.log(data.log);
    });
  }

  log(logString) {
    let toLog = new Date().toLocaleTimeString() + ":  " + logString;
    if (this.logs.length < 15) {
      this.logs.push({
        text: {
          text: toLog,
          fontSize: 20,
          fontFace: "Roboto-Regular",
        },
        color: 0xff00dd00,
      });
    } else {
      let poppedItem = this.logs.shift();
      poppedItem.text.text = toLog;
      this.logs.push(poppedItem);
    }
    this.tag("Logs").children = this.logs;
  }
}
